@if (data) {
    <div class="tooltip-container">
        @if (stepIsOutdated) {
            <fa-icon [icon]="deadlineStatusIcon" class="deadline-nok"></fa-icon>
            Retard de {{ delay }}
        } @else {
            <fa-icon [icon]="deadlineStatusIcon" class="deadline-ok"></fa-icon>
            Délai respecté
        }
        <br />
        <br />
        <label>Début de l'étape: {{ data?.stepStartDate | date: 'dd/MM/yyyy hh:mm' }}</label>
        <br />
        <label>Dernier changement d'état: {{ data?.currentStateDate | date: 'dd/MM/yyyy hh:mm' }}</label>
        <br />
    </div>
}
